/**
 * 门户端-文章类型(新闻资讯、政策相关、成功案例、培训实训)
 */

import request from "@/utils/request";

/**
 * 分页查询
 */
export function getList(params) {
  const { module } = params;
  return request({
    url: "/api/v1/portal/article/list/" + module,
    method: "get",
    params,
  });
}

/**
 * 详情获取
 */
export function getDetails(params) {
  const { id } = params;
  return request({
    url: "/api/v1/portal/article/" + id,
    method: "get",
    params,
  });
}

/**
 * 详情获取
 */
export function docking(data) {
  const { id } = data;
  return request({
    url: "/api/v1/portal/article/link/" + id,
    method: "post",
    data,
  });
}

export default {
  getList,
  getDetails,
  docking,
};
